import React, {useRef} from 'react'
import styles from './return.module.css'
import {Checkbox, Col, InputNumberProps, Row} from 'antd'
import {TOrderInfo} from '../../../api/apiTypes'
import {useTranslation} from 'react-i18next'
import {TRequestReturnOrder} from '../../screens/tracking/type'

import {InputNumber} from '../../molecules/inputNumber/InputNumber'

interface Props extends TOrderInfo {
    defaultChecked: boolean
    onCountChanged: (checked: boolean, order: TRequestReturnOrder) => void
}

export const OrderItem = ({
                              onCountChanged,
                              order_item_number,
                              quantity,
                              options,
                              product_name,
                              defaultChecked,
                          }: Props) => {
    const {t} = useTranslation('return')
    const checkedRef = useRef(defaultChecked)
    const countRef = useRef(quantity)

    const handleCountChanged: InputNumberProps['onChange'] = (count) => {
        console.log('handleCountChanged', count)
        countRef.current = Number(count);
        onCountChanged(checkedRef.current, {order_item_number, product_name, quantity: countRef.current})
    }
    const handleCheckChanged = (e: any) => {
        console.log('handleCheckChanged', e.target.checked)
        checkedRef.current = e.target.checked
        onCountChanged(checkedRef.current, {order_item_number, product_name, quantity: countRef.current})
    }

    return (
        <div className={'column ' + styles.container}>
            <Row className={styles.checkContainer}>
                <Col className={'small1'}>
                    <Checkbox style={{height: 16}} onChange={handleCheckChanged}
                              defaultChecked={defaultChecked}>
                        <div className={'bold ' + styles.order}>{product_name}</div>
                        {!!options && <div className={styles.option}>{t('option', {option: options})}</div>}
                        <div className={styles.option}>{t('quantity', {quantity})}</div>
                    </Checkbox>
                </Col>
            </Row>
            <div className={styles.inputNumber}>
                <InputNumber
                    min={1}
                    max={quantity}
                    defaultValue={quantity}
                    onChange={handleCountChanged}
                />
            </div>
        </div>
    )
}
